export { default } from "../../design-system/atoms/GoogleReCAPTCHA";



// WEBPACK FOOTER //
// ./src/_components/GoogleReCAPTCHA/index.js